import axios, { AxiosHeaders, AxiosRequestConfig, AxiosResponse } from 'axios';
import { redirectToLogin } from './redirectMethods';

export const GET_PERSONAL_SURVEY_PATH = '/';

const requestConfig = {
  headers: {
    'FFF-Auth': 'V1.1',
  },
  withCredentials: true,
};

axios.interceptors.request.use(
  (config: AxiosRequestConfig) => ({
    ...config,
    headers: {
      ...config.headers,
      ...requestConfig.headers,
    } as unknown as AxiosHeaders,
    withCredentials: requestConfig.withCredentials,
  }),
  (error) => Promise.reject(error),
);

axios.interceptors.response.use(
  (_) => _,
  (error) => {
    if (error.response && error.response.status === 401) {
      redirectToLogin();
    } else {
      throw error;
    }
  },
);

const rConfig = (baseURL: string) => ({ baseURL });

const patch = async (baseURL: string, data: unknown, url: string): Promise<AxiosResponse> =>
  axios.patch<AxiosResponse>(url, data, rConfig(baseURL)).then((response) => response);

const get = async (baseURL: string, url: string): Promise<AxiosResponse> =>
  axios.get<AxiosResponse>(url, rConfig(baseURL)).then((response) => response);

const PATHS = {
  newMembers: {
    endTimerSelf: '/new-members/timer/self/stop',
  },
  universalNav: {
    timer: '/timer',
  },
};

export { PATHS, patch, get };
